import React, { useEffect, useState } from 'react'
import './FooterEnds.css'
import logo from '../../Assets/homeLogo.png'
import { FaLinkedin, FaGithub, FaTwitch } from "react-icons/fa";
import { FaSquareBehance } from "react-icons/fa6";
import { Link } from 'react-router-dom';

const useScrollSpy = (sectionIds, offset = 0) => {
    const [activeSection, setActiveSection] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (const id of sectionIds) {
                const element = document.querySelector(id);
                if (element && element.offsetTop <= scrollPosition && element.offsetTop + element.offsetHeight > scrollPosition) {
                    setActiveSection(id);
                    break;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);

    return activeSection;
};

const FooterEnds = () => {
    const sectionIds = ['#GPage', '#Footer'];
    const activeNav = useScrollSpy(sectionIds);
    return (
        <div>
            <footer id='End'>
                <a data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                    data-aos-offset="150"
                    href="#header" className="footer__logo">
                    <img src={logo} alt="logo" />
                </a>

                <ul className='footerlinks'>
                    <li data-aos="fade-up"
                        data-aos-easing="linear"
                        data-aos-duration="200"
                        data-aos-offset="150"><Link to="/" className={activeNav === '#Footer' ? 'active' : ''} >Home</Link></li>
                    <li data-aos="fade-up"
                        data-aos-easing="linear"
                        data-aos-duration="650"
                        data-aos-offset="0"><Link to="/Gallery" className={activeNav === '#GPage' ? 'active' : ''}>Gallery</Link></li>
                    <li data-aos="fade-up"
                        data-aos-easing="linear"
                        data-aos-duration="950"
                        data-aos-offset="0"><a href="https://mohammed-metwally-classic.web.app/">Classic Web.Site</a></li>
                </ul>

                <div className="footer__social">
                    <a data-aos="fade-up-right"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                        data-aos-offset="150" href="https://www.linkedin.com/in/mohamed-metwally-355969248/" target="_blank" rel='noreferrer'><FaLinkedin /></a>
                    <a data-aos="zoom-in-up"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                        data-aos-offset="150" href="https://github.com/Mo-metwally" target="_blank" rel='noreferrer'><FaGithub /></a>
                    <a data-aos="zoom-in-up"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                        data-aos-offset="150" href="https://www.behance.net/mohamedmetwally29" target="_blank" rel='noreferrer'><FaSquareBehance /></a>
                    <a data-aos="fade-up-left"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                        data-aos-offset="150" href="https://www.twitch.tv/eg_aetos" target="_blank" rel='noreferrer'><FaTwitch /></a>

                </div>
                <div className="footer__copy">
                    <small>&copy; M.Metwally. All rights reserved</small>
                </div>

            </footer>
        </div>
    )
}

export default FooterEnds